import lesfurets from '@amo/core/assets/images/logos/landing/100122.png';
import lelynx from '@amo/core/assets/images/logos/landing/101853.svg';
import meilleureassurance from '@amo/core/assets/images/logos/landing/393798.png';
import assurland from '@amo/core/assets/images/logos/landing/67256.png';
import indemnisation from '@amo/core/assets/images/icons/indemnisation.png';
import Calendar from '@amo/core/assets/images/AMO_Icons/Calendar.svg';
import { Multidetention } from '@amo/core/components/containers';
import { getTranslation } from '@amo/core/utils/index.js';
import _ from 'lodash';

import StickyPriceBar from './StickyPriceBar';
import FormuleGrid from './FormuleGrid';
import PersonalizeSection from './PersonalizeSection';
import IncludedGuarantees from './IncludedGuarantees';
import SubscribeSection from './SubscribeSection';
import BlocAvis from '../TableauGarantiesDesktop/BlocAvis/BlocAvis.jsx';
import getFormuleChoisie from '../utilsTarif/getFormuleChoisie';
import './tarif-onepage.scss';

const TarifOnePage = (props) => {
    const {
        data,
        vehicule,
        formules,
        apporteur2,
        IDDevis,
    } = props;

    const formuleChoisie = getFormuleChoisie(data, formules);
    const logos = { 67256: assurland, 100122: lesfurets, 101853: lelynx, 393798: meilleureassurance };
    const categories = ['CUS', 'TRA', 'RTS', 'GRT', 'RBA', 'ROA', 'SPO'];

    return (
        <>
            {/* 1. Banniere Apporteur2 */}
            {apporteur2 && (
                <div className="apporteur2-banner">
                    <div className="apporteur2-banner__inner">
                        <div className="apporteur2-banner__top-row">
                            <div className="apporteur2-banner__logo">
                                {logos[apporteur2.codeBelair] ? (
                                    <img
                                        src={logos[apporteur2.codeBelair]}
                                        alt={apporteur2.name || 'Partenaire'}
                                        width={100}
                                        loading="lazy"
                                    />
                                ) : apporteur2.name ? (
                                    <span className="apporteur2-banner__logo-name">{apporteur2.name}</span>
                                ) : null}
                            </div>
                            {IDDevis && (
                                <div className="apporteur2-banner__devis">
                                    Devis n° <span>{IDDevis}</span>
                                </div>
                            )}
                        </div>
                        <div className="apporteur2-banner__text">
                            <div className="apporteur2-banner__title">
                                Content de vous retrouver !<br />Votre pack {vehicule.brand?.name} n'attend plus que vous.
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 2. Sticky Price Bar */}
            <StickyPriceBar formuleChoisie={formuleChoisie} {...props} />

            {/* 3-7. Contenu principal */}
            <div className="tarif-onepage">
                {/* Card 1 : Je choisis ma formule */}
                <div className="top-card">
                    <div className="top-section-hd">
                        <img src={indemnisation} alt="" loading="lazy" aria-hidden="true" />
                        <div style={{textAlign: 'left'}}>
                            <h2 className="top-section-title">
                                Je choisis ma formule pour assurer mon véhicule
                            </h2>
                            <div className="top-section-sub">
                                {getTranslation('pricing.pricingDescription', {
                                    vehicule: vehicule.brand?.name,
                                })}
                            </div>
                        </div>
                    </div>

                    <FormuleGrid formuleChoisie={formuleChoisie} {...props} />

                    {/* Multidetention */}
                    {_.includes(['moto'], data?.typeVehicule) &&
                        _.includes(categories, data?.code_categorie) &&
                        (_.get(data, 'DemandeTarif[Vehicule][EligibleMultidetention]') === 'true' ||
                            _.get(data, 'DemandeTarif[Vehicule][EligibleMultidetention]') === true) && (
                            <div className="mt-4 text-center">
                                <Multidetention {...props} courtier={false} />
                            </div>
                        )}
                </div>

                {/* Card 2 : Je personnalise mon assurance */}
                <div className="top-card">
                    <div className="top-section-hd top-section-hd--perso">
                        <img src={Calendar} alt="" loading="lazy" aria-hidden="true" />
                        <div style={{textAlign: 'left'}}>
                            <h2 className="top-section-title">
                                Je personnalise mon assurance
                            </h2>
                            <div className="top-section-sub">
                                Maximisez votre protection avec des options qui couvrent chaque aspect de votre sécurité au guidon de votre {vehicule.brand?.name}.
                            </div>
                        </div>
                    </div>

                    <PersonalizeSection {...props} />
                </div>

                {/* Card 3 : Ce qui est inclus */}
                <div className="top-card top-card--included">
                    <IncludedGuarantees formuleChoisie={formuleChoisie} />
                </div>

                {/* Card 4 : Souscrire */}
                <div className="top-card">
                    <SubscribeSection formuleChoisie={formuleChoisie} {...props} />
                </div>

                {/* Card 5 : Avis */}
                <BlocAvis {...props} />
            </div>
        </>
    );
};

export default TarifOnePage;
